import { render, staticRenderFns } from "./sortOnTrial.vue?vue&type=template&id=d45422c2&scoped=true&"
import script from "./sortOnTrial.vue?vue&type=script&lang=js&"
export * from "./sortOnTrial.vue?vue&type=script&lang=js&"
import style0 from "./sortOnTrial.vue?vue&type=style&index=0&id=d45422c2&lang=scss&scoped=true&"
import style1 from "./sortOnTrial.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45422c2",
  null
  
)

export default component.exports